document.addEventListener("DOMContentLoaded", function() {

    const state = {

        appWrapper: null,
        productForm: null,
        blockSettings: null,
        variants: null,
        selectedVariantId: null,
        variantMap: null,
        selectors: null,

        option1Title: null,
        option2Title: null,


        allOption1Values: [],
        allOption2Values: [],
        colorsMap: {}
        
    }

    function main() {
        setupStateData();

        render();

        setupEventListeners();
        
        // Set initial line item properties on page load
        if (state.selectedVariantId && state.variantMap[state.selectedVariantId]) {
            updateLineItemProperties(state.variantMap[state.selectedVariantId]);
        }
        
        // Set initial size availability based on selected option1
        const activeColorSwatch = state.appWrapper.querySelector('.we-selectors-color-swatch.active');
        const activeDropdownItem = state.appWrapper.querySelector('.we-size-dropdown-container .variant-picker-dropdown__item.selected');
        
        let initialOption1Value = null;
        if (activeColorSwatch) {
            initialOption1Value = activeColorSwatch.getAttribute('data-color');
        } else if (activeDropdownItem) {
            initialOption1Value = activeDropdownItem.getAttribute('data-size');
        }
        
        // Ensure option1 is always available
        ensureOption1AlwaysAvailable();
        
        if (initialOption1Value) {
            updateOption2Availability(initialOption1Value);
        }
        
        // Listen for variant picker changes to ensure our line item properties stay in sync
        document.addEventListener('variant:change', function(event) {
            if (event.detail && event.detail.variant) {
                updateLineItemProperties(event.detail.variant);
            }
        });
    }

    function setupStateData() {
        state.blockSettings = weBlockSettings;
        state.variants = we_variants;
        state.selectedVariantId = weSelectedVariantId;
        state.colorsMap = colorsMap;
        state.variantMap = {}
        state.variants.forEach(variant => {
            state.variantMap[variant.id] = variant;
        });
        state.appWrapper = document.querySelector('.we-selectors');
        
        // Find the product form
        state.productForm = document.querySelector('form[action*="/cart/add"]');

        state.allOption1Values = new Set();
        state.allOption2Values = new Set();

        state.variants.forEach(variant => {
            state.allOption1Values.add(variant.metafields.option_1_value);
            state.allOption2Values.add(variant.metafields.option_2_value);
        });

        state.allOption1Values = Array.from(state.allOption1Values);
        state.allOption2Values = Array.from(state.allOption2Values);


        state.option1Title = state.variantMap[state.selectedVariantId].metafields.option_1_name;
        state.option2Title = state.variantMap[state.selectedVariantId].metafields.option_2_name;

    }

    function render(){
        if(!state.option1Title){
            return;
        }
        const enableSwatches = state.blockSettings.enable_swatches.toLowerCase().split(',');
        if(enableSwatches.includes(state.option1Title.toLowerCase())){
            const colorSwatches = createColorSwatches("option_1", state.option1Title, state.allOption1Values);
            state.appWrapper.appendChild(colorSwatches);
        } else{
            const sizeDropdown = createSizeDropdown("option_1", state.option1Title, state.allOption1Values);
            state.appWrapper.appendChild(sizeDropdown);
            
            // Hide dropdown container if only 1 size option
            if (state.allOption1Values.length === 1) {
                const dropdownContainer = state.appWrapper.querySelector('.we-size-dropdown-container');
                if (dropdownContainer) {
                    dropdownContainer.style.display = 'none';
                }
            }
        }

        if(!state.option2Title){
            return;
        }

        if(enableSwatches.includes(state.option2Title.toLowerCase())){
            const colorSwatches = createColorSwatches("option_2", state.option2Title, state.allOption2Values);
            state.appWrapper.appendChild(colorSwatches);
        } else{
            const sizeDropdown = createSizeDropdown("option_2", state.option2Title, state.allOption2Values);
            state.appWrapper.appendChild(sizeDropdown);
            
            // Hide dropdown container if only 1 size option
            if (state.allOption2Values.length === 1) {
                const dropdownContainer = state.appWrapper.querySelector('.we-size-dropdown-container');
                if (dropdownContainer) {
                    dropdownContainer.style.display = 'none';
                }
            }
        }
    }

    function isOptionValueAvailable(option, value) {
        const optionValueKey = option + '_value';

        return state.variants.some(variant => {
            return variant &&
                variant.available === true &&
                variant.metafields &&
                variant.metafields[optionValueKey] === value;
        });
    }

    function sortOptionValuesByAvailability(option, optionValues) {
        return optionValues
            .map((value, originalIndex) => ({
                value,
                originalIndex,
                available: isOptionValueAvailable(option, value)
            }))
            .sort((first, second) => {
                if (first.available !== second.available) {
                    return first.available ? -1 : 1;
                }

                return first.originalIndex - second.originalIndex;
            })
            .map(item => item.value);
    }

    function createColorSwatches(option, title, allOptionValues){
        const optionValue = state.variantMap[state.selectedVariantId].metafields[option + '_value'];
        const optionValueKey = option + '_value';
        const sortedOptionValues = sortOptionValuesByAvailability(option, allOptionValues);
        const wrapper = document.createElement('div');
        const swatchesWrapper = document.createElement('div');
        const option1Title = document.createElement('div');
        option1Title.classList.add('we-selectors-option-1-title');
        const titleSpan = document.createElement('span');
        titleSpan.classList.add('we-selectors-option-1-title-span');
        titleSpan.textContent = title + ':';
        
        const option1Value = document.createElement('div');
        option1Value.classList.add('we-selectors-option-1-value');
        option1Value.textContent = optionValue;
        swatchesWrapper.classList.add('we-selectors-color-swatches');
        wrapper.classList.add('we-selectors-wrapper');

        option1Title.appendChild(titleSpan);
        option1Title.appendChild(option1Value);
        wrapper.appendChild(option1Title);
        wrapper.appendChild(swatchesWrapper);

        for(const value of sortedOptionValues){
            const isAvailable = isOptionValueAvailable(option, value);
            const colorSwatch = document.createElement('div');
            colorSwatch.classList.add('we-selectors-color-swatch');
            if(optionValue === value){
                colorSwatch.classList.add('active');
            }
            if(!isAvailable){
                colorSwatch.classList.add('sold-out');
            }
            colorSwatch.style.backgroundColor = state.colorsMap[value.toLowerCase()];
            colorSwatch.setAttribute('data-available', isAvailable ? 'true' : 'false');
            colorSwatch.setAttribute('aria-label', isAvailable ? value : value + ' - Ausverkauft');
            colorSwatch.setAttribute('title', isAvailable ? value : value + ' - Ausverkauft');
            
            // Prefer an available variant for this option value. If the whole
            // color is sold out, keep the first matching variant selectable.
            const variantsForColor = state.variants.filter(variant =>
                variant &&
                variant.metafields &&
                variant.metafields[optionValueKey] === value
            );
            const variantForColor = variantsForColor.find(variant => variant.available) || variantsForColor[0];
            
            colorSwatch.setAttribute('data-color', value);
            if (variantForColor) {
                colorSwatch.setAttribute('data-variant-id', variantForColor.id);
            }
            
            swatchesWrapper.appendChild(colorSwatch);
        }
        return wrapper;
    }

    function createSizeDropdown(option, title, allOptionValues){
        const variantOptionValue = state.variantMap[state.selectedVariantId].metafields[option + '_value'];
        const wrapper = document.createElement('div');
        wrapper.classList.add('we-selectors-size-dropdown-wrapper');
        
        // Create the option label
        const optionLabel = document.createElement('div');
        optionLabel.classList.add('we-selectors-option-2-title');
        const titleSpan = document.createElement('span');
        titleSpan.classList.add('we-selectors-option-2-title-span');
        titleSpan.textContent = title + ':';
        
        const optionValue = document.createElement('div');
        optionValue.classList.add('we-selectors-option-2-value');
        optionValue.textContent = variantOptionValue;
        
        optionLabel.appendChild(titleSpan);
        optionLabel.appendChild(optionValue);
        
        // Create custom dropdown container
        const dropdownContainer = document.createElement('div');
        dropdownContainer.classList.add('we-size-dropdown-container');
        
        // Create dropdown toggle button
        const dropdownToggle = document.createElement('button');
        dropdownToggle.classList.add('variant-picker-dropdown__toggle', 'variant-picker-dropdown__toggle--outline');
        dropdownToggle.setAttribute('type', 'button');
        dropdownToggle.setAttribute('aria-expanded', 'false');
        dropdownToggle.setAttribute('tabindex', '0');
        
        // Create toggle label
        const toggleLabel = document.createElement('div');
        toggleLabel.classList.add('variant-picker-dropdown__toggle-label');
        const toggleSpan = document.createElement('span');
        toggleSpan.textContent = variantOptionValue;
        toggleLabel.appendChild(toggleSpan);
        
        // Create chevron icon
        const chevron = document.createElement('div');
        chevron.classList.add('variant-picker-dropdown__chevron');
        chevron.innerHTML = '<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        
        dropdownToggle.appendChild(toggleLabel);
        dropdownToggle.appendChild(chevron);
        
        // Create dropdown menu
        const dropdownMenu = document.createElement('div');
        dropdownMenu.classList.add('variant-picker-dropdown');
        
        // Create dropdown body
        const dropdownBody = document.createElement('div');
        dropdownBody.classList.add('variant-picker-dropdown__body');
        
        // Create dropdown items from allOption2Values
        allOptionValues.forEach((value) => {
            const item = document.createElement('div');
            item.classList.add('variant-picker-dropdown__item');
            if (variantOptionValue === value) {
                item.classList.add('selected');
            }
            item.setAttribute('data-value', value);
            item.setAttribute('data-size', value);
            
            // Find the variant ID for this size
            const variantForSize = state.variants.find(variant => 
                variant.metafields[option + '_value'] === value
            );
            
            if (variantForSize) {
                item.setAttribute('data-variant-id', variantForSize.id);
            }
            
            const span = document.createElement('span');
            span.textContent = value;
            item.appendChild(span);
            
            dropdownBody.appendChild(item);
        });
        
        dropdownMenu.appendChild(dropdownBody);
        dropdownContainer.appendChild(dropdownToggle);
        dropdownContainer.appendChild(dropdownMenu);
        
        // Assemble the wrapper
        wrapper.appendChild(optionLabel);
        wrapper.appendChild(dropdownContainer);
        
        return wrapper;
    }


    
    function setupEventListeners() {
        // Color swatch click handlers
        const colorSwatches = state.appWrapper.querySelectorAll('.we-selectors-color-swatch');
        colorSwatches.forEach(swatch => {
            swatch.addEventListener('click', function() {
                // Remove active class from all swatches
                if(swatch.classList.contains('active')){
                    return;
                }

                
                colorSwatches.forEach(s => s.classList.remove('active'));
                // Add active class to clicked swatch
                swatch.classList.add('active');
                
                // Update the displayed color value
                const option1Value = state.appWrapper.querySelector('.we-selectors-option-1-value');
                if (option1Value) {
                    const colorValue = swatch.getAttribute('data-color');
                    option1Value.textContent = colorValue;
                }
                
                // Find and select the corresponding variant
                const colorValue = swatch.getAttribute('data-color');
                const variantId = swatch.getAttribute('data-variant-id');
                let variant = state.variantMap[variantId];
                
                if (variant) {
                    // If option2Title is empty, just use the variant directly
                    if (!state.option2Title) {
                        // Update the displayed color value
                        const option1Value = state.appWrapper.querySelector('.we-selectors-option-1-value');
                        if (option1Value) {
                            option1Value.textContent = colorValue;
                        }
                        
                        // Find and click the corresponding variant picker dropdown item
                        clickVariantPickerItem(variant);
                        
                        // Update line item properties
                        updateLineItemProperties(variant);
                    } else {
                        // Original complex logic for when option2Title exists
                        if (colorValue) {
                            selectVariantByOptions(colorValue, null);
                        }
                        
                        // Ensure option1 stays available and update option2 availability
                        ensureOption1AlwaysAvailable();
                        updateOption2Availability(colorValue);
                        
                        // Check if current option2 exists for this option1
                        const enableSwatches = state.blockSettings.enable_swatches.toLowerCase().split(',');
                        const isOption2Swatch = enableSwatches.includes(state.option2Title.toLowerCase());
                        
                        let currentOption2Value = null;
                        if (isOption2Swatch) {
                            // Option2 is swatch, get current swatch value
                            const activeSwatch = state.appWrapper.querySelector('.we-selectors-color-swatch.active');
                            currentOption2Value = activeSwatch ? activeSwatch.getAttribute('data-color') : null;
                        } else {
                            // Option2 is dropdown, get current dropdown value
                            currentOption2Value = getCurrentSelectedSize();
                        }
                        
                        const variantWithCurrentOption2 = findVariantByOptions(colorValue, currentOption2Value);
                        
                        if (!variantWithCurrentOption2 && currentOption2Value) {
                            // Find any option2 that exists for this option1
                            const availableOption2Values = getAvailableOption2Values(colorValue);
                            if (availableOption2Values.length > 0) {
                                const newOption2Value = availableOption2Values[0]; // Use first available option2
                                
                                // Update option2 display
                                if (isOption2Swatch) {
                                    // Update swatch display
                                    updateSizeDisplay(newOption2Value);
                                } else {
                                    // Update dropdown display
                                    updateSizeDisplay(newOption2Value);
                                }
                                
                                // Find variant with new option2
                                const newVariant = findVariantByOptions(colorValue, newOption2Value);
                                if (newVariant) {
                                    variant = newVariant;
                                }
                            }
                        }
                        
                        // Find and click the corresponding variant picker dropdown item first
                        clickVariantPickerItem(variant);
                        
                        // Update line item properties immediately (the global listener will handle sync)
                        updateLineItemProperties(variant);
                    }
                } else {
                    console.log('❌ No variant found for variantId:', variantId);
                }
            });
        });
        
        // Dropdown toggle
        const dropdownToggle = state.appWrapper.querySelector('.we-size-dropdown-container button');
        const dropdownMenu = state.appWrapper.querySelector('.we-size-dropdown-container .variant-picker-dropdown');
        
        if (dropdownToggle && dropdownMenu) {
            dropdownToggle.addEventListener('click', function(e) {
                e.stopPropagation();
                dropdownMenu.classList.toggle('is-open');
            });
            
            // Close on outside click
            document.addEventListener('click', function(e) {
                const isClickInside = state.appWrapper.querySelector('.we-size-dropdown-container').contains(e.target);
                if (!isClickInside) {
                    dropdownMenu.classList.remove('is-open');
                }
            });
        }
        
        // Size dropdown item click handlers
        const sizeDropdownItems = state.appWrapper.querySelectorAll('.we-size-dropdown-container .variant-picker-dropdown__item');
        sizeDropdownItems.forEach(item => {
            item.addEventListener('click', function(e) {
                e.stopPropagation();
                    const selectedValue = item.getAttribute('data-size');
                    const variantId = item.getAttribute('data-variant-id');
                    
                    // Check if this size is already selected
                    if (item.classList.contains('selected')) {
                        console.log('📏 Size already selected, returning:', selectedValue);
                        return;
                    }
                    
                    // Check if this size is unavailable/disabled
                    if (item.classList.contains('unavailable')) {
                        console.log('📏 Size unavailable for current color, returning:', selectedValue);
                        return;
                    }
                    
                    // Get the variant directly from the clicked element
                    const variant = state.variantMap[variantId];
                    
                    if (variant) {
                        // If option2Title is empty, just use the variant directly
                        if (!state.option2Title) {
                            // Update selection
                            sizeDropdownItems.forEach(i => i.classList.remove('selected'));
                            item.classList.add('selected');
                            
                            // Update display
                            const toggleLabel = state.appWrapper.querySelector('.we-size-dropdown-container .variant-picker-dropdown__toggle-label span');
                            const option2Value = state.appWrapper.querySelector('.we-selectors-option-2-value');
                            if (toggleLabel) toggleLabel.textContent = selectedValue;
                            if (option2Value) option2Value.textContent = selectedValue;
                            
                            // Close dropdown
                            dropdownMenu.classList.remove('is-open');
                            
                            // Find and click the corresponding variant picker dropdown item
                            clickVariantPickerItem(variant);
                            
                            // Update line item properties
                            updateLineItemProperties(variant);
                            
                            // Ensure option1 stays available and update option2 availability
                            ensureOption1AlwaysAvailable();
                            updateOption2Availability(selectedValue);
                        } else {
                            // Original complex logic for when option2Title exists (multi-option product)
                            const enableSwatches = state.blockSettings.enable_swatches.toLowerCase().split(',');
                            const isOption1Swatch = enableSwatches.includes(state.option1Title.toLowerCase());
                            const isOption2Swatch = enableSwatches.includes(state.option2Title.toLowerCase());
                            
                            // Determine which option this dropdown represents
                            let option1Value, option2Value;
                            if (isOption1Swatch) {
                                // This dropdown is option2, get option1 from swatch
                                const activeSwatch = state.appWrapper.querySelector('.we-selectors-color-swatch.active');
                                option1Value = activeSwatch ? activeSwatch.getAttribute('data-color') : null;
                                option2Value = selectedValue;
                            } else {
                                // This dropdown is option1, get option2 from swatch
                                option1Value = selectedValue;
                                const activeSwatch = state.appWrapper.querySelector('.we-selectors-color-swatch.active');
                                option2Value = activeSwatch ? activeSwatch.getAttribute('data-color') : null;
                            }
                            
                            // Find variant that matches both options
                            const matchingVariant = findVariantByOptions(option1Value, option2Value);
                            
                            if (matchingVariant) {
                                // Update selection
                                sizeDropdownItems.forEach(i => i.classList.remove('selected'));
                                item.classList.add('selected');
                                
                                // Update display
                                const toggleLabel = state.appWrapper.querySelector('.we-size-dropdown-container .variant-picker-dropdown__toggle-label span');
                                const option2Value = state.appWrapper.querySelector('.we-selectors-option-2-value');
                                if (toggleLabel) toggleLabel.textContent = selectedValue;
                                if (option2Value) option2Value.textContent = selectedValue;
                                
                                // Close dropdown
                                dropdownMenu.classList.remove('is-open');
                                
                                // Find and click the corresponding variant picker dropdown item first
                                clickVariantPickerItem(matchingVariant);
                                
                                // Update line item properties immediately (the global listener will handle sync)
                                updateLineItemProperties(matchingVariant);
                            } else {
                                console.log('❌ No variant found for option1:', option1Value, 'and option2:', option2Value);
                            }
                        }
                    } else {
                        console.log('❌ No variant found for variantId:', variantId);
                    }
            });
        });
    }
    
    function selectVariantByOptions(option1Value, option2Value) {
        // Find variant that matches both options
        const matchingVariant = findVariantByOptions(option1Value, option2Value);
        
        if (matchingVariant) {
            state.selectedVariantId = matchingVariant.id;
            
            // Find and click the corresponding variant picker dropdown item
            clickVariantPickerItem(matchingVariant);
        }
    }
    
    function findVariantByOptions(option1Value, option2Value) {
        // Prefer an available variant when more than one variant matches (for
        // example, when only a color and no size has been selected yet).
        const matchingVariants = state.variants.filter(variant => {
            if (!variant || !variant.metafields) return false;
            const matchesOption1 = option1Value === null || variant.metafields.option_1_value === option1Value;
            const matchesOption2 = option2Value === null || variant.metafields.option_2_value === option2Value;
            return matchesOption1 && matchesOption2;
        });

        return matchingVariants.find(variant => variant.available) || matchingVariants[0];
    }
    
    function getCurrentSelectedSize() {
        const selectedSizeItem = state.appWrapper.querySelector('.we-size-dropdown-container .variant-picker-dropdown__item.selected');
        return selectedSizeItem ? selectedSizeItem.getAttribute('data-size') : null;
    }
    
    function getAvailableOption2Values(option1Value) {
        const availableOption2Values = new Set();
        state.variants.forEach(variant => {
            if (variant && variant.metafields && variant.metafields.option_1_value === option1Value) {
                availableOption2Values.add(variant.metafields.option_2_value);
            }
        });
        return Array.from(availableOption2Values);
    }
    
    function updateSizeDisplay(newSize) {
        // Update dropdown toggle label
        const toggleLabel = state.appWrapper.querySelector('.we-size-dropdown-container .variant-picker-dropdown__toggle-label span');
        if (toggleLabel) {
            toggleLabel.textContent = newSize;
        }
        
        // Update option 2 value display
        const option2Value = state.appWrapper.querySelector('.we-selectors-option-2-value');
        if (option2Value) {
            option2Value.textContent = newSize;
        }
        
        // Update selected state in dropdown
        const sizeDropdownItems = state.appWrapper.querySelectorAll('.we-size-dropdown-container .variant-picker-dropdown__item');
        sizeDropdownItems.forEach(item => {
            item.classList.remove('selected');
            if (item.getAttribute('data-size') === newSize) {
                item.classList.add('selected');
            }
        });
        
    }
    
    function ensureOption1AlwaysAvailable() {
        // Ensure option1 elements are always available (never disabled)
        const enableSwatches = state.blockSettings.enable_swatches.toLowerCase().split(',');
        const isOption1Swatch = enableSwatches.includes(state.option1Title.toLowerCase());
        
        if (isOption1Swatch) {
            // Ensure option1 swatches are always available
            const option1Swatches = state.appWrapper.querySelectorAll('.we-selectors-color-swatch');
            option1Swatches.forEach(swatch => {
                swatch.classList.remove('unavailable');
                swatch.style.opacity = '1';
            });
        } else {
            // Ensure option1 dropdown items are always available
            const option1DropdownItems = state.appWrapper.querySelectorAll('.we-size-dropdown-container .variant-picker-dropdown__item');
            option1DropdownItems.forEach(item => {
                item.classList.remove('unavailable');
                item.style.opacity = '1';
            });
        }
    }
    
    function updateOption2Availability(option1Value) {
        // Only update option2 elements based on option1 selection
        // Option1 should always be available, only option2 gets filtered
        
        const enableSwatches = state.blockSettings.enable_swatches.toLowerCase().split(',');
        const isOption1Swatch = enableSwatches.includes(state.option1Title.toLowerCase());
        const isOption2Swatch = enableSwatches.includes(state.option2Title.toLowerCase());
        
        const availableOption2Values = getAvailableOption2Values(option1Value);
        
        if (isOption2Swatch) {
            // Update swatches for option2
            const option2Swatches = state.appWrapper.querySelectorAll('.we-selectors-color-swatch');
            option2Swatches.forEach(swatch => {
                const swatchValue = swatch.getAttribute('data-color');
                const isAvailable = availableOption2Values.includes(swatchValue);
                
                if (isAvailable) {
                    swatch.classList.remove('unavailable');
                    swatch.style.opacity = '1';
                } else {
                    swatch.classList.add('unavailable');
                    swatch.style.opacity = '0.3';
                }
            });
        } else {
            // Update dropdown items for option2
            const option2DropdownItems = state.appWrapper.querySelectorAll('.we-size-dropdown-container .variant-picker-dropdown__item');
            option2DropdownItems.forEach(item => {
                const itemValue = item.getAttribute('data-size');
                const isAvailable = availableOption2Values.includes(itemValue);
                
                if (isAvailable) {
                    item.classList.remove('unavailable');
                    item.style.opacity = '1';
                } else {
                    item.classList.add('unavailable');
                    item.style.opacity = '0.3';
                }
            });
        }
    }
    
    function clickVariantPickerItem(variant) {
        // Find the variant picker component
        const variantPicker = document.querySelector('variant-picker');
        
        if (!variantPicker) {
            console.log('❌ No variant picker found');
            return;
        }
        
        // First, try to find dropdown opener and open it
        const dropdownOpener = variantPicker.querySelector('.variant-picker-dropdown__toggle');
        
        if (dropdownOpener) {
            dropdownOpener.click();
            
            // Wait a bit for the dropdown to open, then look for items
            setTimeout(() => {
                findAndClickItem(variant, variantPicker);
            }, 100);
        } else {
            // Try to find items directly (maybe they're always rendered)
            findAndClickItem(variant, variantPicker);
        }
    }
    
    function findAndClickItem(variant, variantPicker) {
        // Find all variant picker dropdown items
        const dropdownItems = variantPicker.querySelectorAll('.variant-picker-dropdown__item');
        
        // Look for the item with matching data-value (variant title)
        let foundMatch = false;
        dropdownItems.forEach((item, index) => {
            const itemValue = item.getAttribute('data-value');
            
            if (itemValue === variant.title) {
                // Click the item to trigger the theme's native behavior
                item.click();
                foundMatch = true;
            }
        });
        
        if (!foundMatch) {
            console.log('❌ No matching dropdown item found for variant title:', variant.title);
        }
    }
    
    function updateLineItemProperties(variant) {
        if (!state.productForm) {
            console.log('❌ No product form found for line item properties');
            return;
        }
        
        if (!variant) {
            console.log('❌ Invalid variant:', variant);
            return;
        }
        
        // Look up our internal variant object using the variant ID
        const internalVariant = state.variantMap[variant.id];
        if (!internalVariant || !internalVariant.metafields) {
            console.log('❌ Internal variant not found for ID:', variant.id);
            return;
        }
        
        // Get option values from our internal variant
        const option1Value = internalVariant.metafields.option_1_value;
        const option2Value = internalVariant.metafields.option_2_value;
        
        // Update or create line item properties using actual option titles
        updateLineItemProperty(state.option1Title, option1Value);
        updateLineItemProperty(state.option2Title, option2Value);
    }
    
    function updateLineItemProperty(key, value) {
        if (!value) return;
        
        // Remove existing property
        const existingInput = state.productForm.querySelector(`input[name="properties[${key}]"]`);
        if (existingInput) {
            existingInput.remove();
        }
        
        // Add new property
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${key}]`;
        input.value = value;
        state.productForm.appendChild(input);
        
    }

    main(); 
})  
